export function isHourInRange(hour, range) {
  if (range[0] < 0 || range[0] >= 24 || range[1] < 0 || range[1] >= 24) {
    throw new Error('Hour range should be in range [0, 24[');
  }
  if (hour < 0 || hour >= 24) {
    throw new Error('hour value should be in range [0, 24[');
  }

  if (hour > range[0] && hour < range[1]) return true;
  if (range[0] > range[1]) {
    if (hour > range[0]) return true;
    if (hour < range[1]) return true;
  }
  return false;
}

/**
 * Returns the number of hours until the next targetHour (could be next day), starting at startDate
 * @param {number} targetHour [0,24[
 * @param {Date} startDate if null, this is set to the current local time
 * @return {number}
 */
export function timeToNextOccurenceOfHour(targetHour, startDate=null) {
  if (startDate === null) startDate = new Date();

  const targetDate = new Date(startDate);
  if (startDate.getHours() >= targetHour) {
    targetDate.setDate(targetDate.getDate()+1);
  }
  targetDate.setHours(targetHour);
  targetDate.setMinutes(0);

  const delta_millis = targetDate - startDate;
  const delta_hours = delta_millis / 1000 / 60 / 60;
  const delta_minutes = (delta_millis / 1000 / 60) % 60;
  // throw new Error(Math.floor(delta_millis/1000/60/60));

  return [Math.floor(delta_hours), Math.floor(delta_minutes)];
}

export function makeTime(hours=0, minutes=0, seconds=0) {
  if (typeof hours === 'string') {
    [hours, minutes, seconds] = hours.split(':').map((val)=>parseFloat(val));
  }
  return new Date(0, 0, 0, hours||0, minutes||0, seconds||0, 0);
}
